import React, { useEffect, useRef } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import { OktaAuth } from '@okta/okta-auth-js';
import { useNavigate } from 'react-router-dom';
import { envConfig } from '@/config/envConfig';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
export const oktaAuth = new OktaAuth(envConfig);
import oktaLogo from '@/assets/logo/logo_color.svg';

const LoginPage: React.FC = () => {
  const widgetRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
console.log("envConfig",envConfig)
const externalUserNamePrefix = 'APV__';
  const internalUserIDMaxLength = 8;
  useEffect(() => {
    if (widgetRef.current) widgetRef.current.innerHTML = '';

    let oktaContainer = new OktaSignIn({
      el: '#okta-signin-container',
      baseUrl: envConfig.baseURL,
      clientId: envConfig.clientId,
      redirectUri: envConfig.redirectUri,
      logo: oktaLogo,
      useClassicEngine: true,
      authParams: {
        pkce: true,
        issuer: envConfig.issuer,
        scopes: envConfig.scopes,
      },
      features: {
        registration: false,
        webauthn: true,
        passwordlessAuth: true,
        multiOptionalFactorEnroll: true,
      },
       transformUsername: (username) => {
        if (
          username.length > internalUserIDMaxLength &&
          username.indexOf(externalUserNamePrefix) == -1
        ) {
          username = externalUserNamePrefix + username;
        }
        return username;
      },
      i18n: {
        en: {
          'primaryauth.title': 'Track360',
        },
      },
      helpLinks: {
        help:envConfig.oktaBaseURL + '/help/login'
      }
    });

    (async () => {
      try {
        const hasOktaSession = await oktaAuth.session.exists();
        if (hasOktaSession) {
          console.info('User has existing Okta session.');
          const res = await oktaAuth.token.getWithoutPrompt();
          try {
            if (res.tokens.idToken?.idToken) {
              await oktaAuth.handleLoginRedirect(res.tokens);
              localStorage.setItem('auth_token', res.tokens.idToken.idToken);
              void navigate('/search');
            } else {
              void navigate('/login');
            }
          } catch (redirectError) {
            console.error('Error during login redirect:', redirectError);
          }
        } else {
          console.info('No existing Okta session. Displaying login widget...');
          const res = await oktaContainer.showSignInToGetTokens();
          try {
            if (res.idToken?.idToken) {
              await oktaAuth.handleLoginRedirect(res);
              localStorage.setItem('auth_token', res.idToken.idToken);
              void navigate('/search');
            } else {
              void navigate('/login');
            }
          } catch (redirectError) {
            console.error('Error during login redirect:', redirectError);
          }
        }
      } catch (error) {
        console.error('Authentication error:', error);
      }
    })().catch((error: unknown) => {
      console.error('Unhandled error in authentication flow:', error);
    });

    return () => {
      oktaContainer.remove();
    };
  }, []);

  return (
    <div className="login">
      <div ref={widgetRef} id="okta-signin-container" />
    </div>
  );
};

export default LoginPage;
